export enum EventFileTypeCode{
    EventImage = 0,
    EventVenueMapImage = 1
}